import React from 'react';
import { Box } from '@mui/material';
import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { PieChart } from '@/common/dashboard/charts/PieChart';
import { ChecklistDisplay } from './ChecklistDisplay.jsx';
import { Spacer } from '@/common/layout/SpacerLayout';

export const StatusColumn = ({ title, icon, data }) => {
  if (!data) return null;

  const { items = [], counts = {} } = data;

  // Prepare pie chart data
  const pieData = [
    { label: 'Success', value: counts.SUCCESS || 0, color: '#2e7d32' },
    { label: 'Fail', value: counts.FAIL || 0, color: '#d32f2f' },
    { label: 'Not Run', value: counts.NOT_RUN || 0, color: '#757575' },
  ].filter(d => d.value > 0);

  const total = counts.TOTAL || 0;
  const successRate = total > 0 ? Math.round((counts.SUCCESS / total) * 100) : 0;

  return (
    <DashboardCard title={title} icon={icon}>
      <Spacer vertical gap={2}>
        {/* Pie Chart */}
        <Box sx={{ height: 250 }}>
          <PieChart
            data={pieData}
            legend="bottom"
            dataLabels={false}
            innerSize="70%"
            centerLabel={`${successRate}%`}
            centerSubLabel="Success"
          />
        </Box>

        {/* Checklist */}
        <ChecklistDisplay items={items} />
      </Spacer>
    </DashboardCard>
  );
};